module.exports = __webpack_public_path__ + "img/p2-p1-shou.0a7a0683.png";